import { ChildrenState } from "./../models/ChildrenState";
import { FamilyFormState } from "./../models/FamilyFormState";

export type ChildrenAction =
  | {
      type: "start_add";
    }
  | {
      type: "close";
    }
  | {
      type: "start_edit";
      payload: number;
    }
  | {
      type: "add";
      payload: FamilyFormState;
    }
  | {
      type: "delete";
      payload: number;
    };

export function childrenReducer(
  state: ChildrenState,
  action: ChildrenAction
): ChildrenState {
  switch (action.type) {
    case "start_add": {
      return { ...state, showModal: true, editing: undefined };
    }
    case "add": {
      let children = state.children;
      if (action.payload.id) {
        children = children.map((child) =>
          child.id !== action.payload.id ? child : action.payload
        );
      } else {
        const child = {
          ...action.payload,
          id: children.reduce(
            (id, child) => (child.id >= id ? child.id + 1 : id),
            1
          ),
        };
        children = children.concat(child);
      }
      return { ...state, children, editing: undefined, showModal: false };
    }
    case "close": {
      return { ...state, showModal: false, editing: undefined };
    }
    case "delete": {
      return {
        ...state,
        editing: undefined,
        children: state.children.filter((child) => child.id !== action.payload),
      };
    }
    case "start_edit": {
      return {
        ...state,
        showModal: true,
        editing: state.children.find((child) => child.id === action.payload),
      };
    }
    default:
      console.debug("childrenReducer unprocessed action:", action);
  }
  return state;
}
